/* OR category filtering over the complete, paginated collection. */
(function () {
  const instances = new WeakMap();
  function initCatalog(root, {fetcher = fetch} = {}) {
    if (instances.has(root)) return instances.get(root);
    const document = root.ownerDocument;
    const grid = root.querySelector('[data-pg-catalog-grid]');
    const buttons = [...root.querySelectorAll('[data-pg-category]')];
    const clear = root.querySelector('[data-pg-clear]');
    const syncClear = () => { clear.hidden = !buttons.some(button => button.getAttribute('aria-pressed') === 'true'); };
    const status = root.querySelector('[data-pg-filter-status]');
    const pagination = root.querySelector('[data-pg-pagination]');
    let products, loading, revision = 0, work = Promise.resolve();
    async function loadAll() {
      if (products) return products;
      if (loading) return loading;
      loading = (async () => {
        const cards = new Map();
        const collect = scope => scope.querySelectorAll('[data-pg-catalog-product]').forEach(card => cards.set(card.dataset.pgCatalogProduct, card));
        let next;
        if (root.dataset.pgCatalogPage === '1') {
          collect(grid);
          next = root.querySelector('[data-pg-next]')?.getAttribute('href');
        } else next = root.dataset.pgCatalogStart;
        const visited = new Set();
        while (next) {
          const url = new URL(next, document.baseURI);
          if (url.origin !== new URL(document.baseURI).origin || visited.has(url.href)) throw new Error('Invalid catalog pagination');
          visited.add(url.href);
          const response = await fetcher(url.href, {headers: {Accept: 'text/html'}});
          if (!response.ok) throw new Error('Catalog unavailable');
          const page = new document.defaultView.DOMParser().parseFromString(await response.text(), 'text/html');
          const catalog = page.querySelector('[data-pg-catalog]');
          if (!catalog?.querySelector('[data-pg-catalog-grid]')) throw new Error('Missing catalog');
          collect(catalog);
          next = catalog.querySelector('[data-pg-next]')?.getAttribute('href');
        }
        products = [...cards.values()];
        grid.replaceChildren(...products);
        if (pagination) pagination.hidden = true;
        return products;
      })();
      try { return await loading; } finally { loading = null; }
    }
    async function filter() {
      syncClear();
      const current = ++revision;
      status.textContent = clear.hidden ? '' : root.dataset.loading;
      grid.setAttribute('aria-busy', 'true');
      try {
        const cards = await loadAll();
        if (current !== revision) return;
        const selected = buttons.filter(button => button.getAttribute('aria-pressed') === 'true').map(button => button.dataset.pgCategory);
        let count = 0;
        cards.forEach(card => {
          const tags = (card.dataset.pgTags || '').split('|').map(tag => tag.trim().toLowerCase());
          card.hidden = selected.length > 0 && !selected.some(tag => tags.includes(tag));
          if (!card.hidden) count++;
        });
        root.querySelector('[data-pg-filter-empty]').hidden = count !== 0;
        status.textContent = selected.length ? root.dataset.count.replace('{count}', count) : '';
      } catch (_) {
        if (current === revision) status.textContent = root.dataset.error;
      } finally {
        if (current === revision) grid.removeAttribute('aria-busy');
      }
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      work = filter();
    }));
    clear.addEventListener('click', () => {
      buttons.forEach(button => button.setAttribute('aria-pressed', 'false'));
      work = filter();
    });
    syncClear();
    root.querySelector('[data-pg-filters]').hidden = false;
    const api = {settled: () => work};
    instances.set(root, api);
    return api;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {initCatalog};
  if (typeof document === 'undefined') return;
  const scan = () => document.querySelectorAll('[data-pg-catalog]').forEach(root => initCatalog(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true}); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
